import { render, staticRenderFns } from "./Franchigia.vue?vue&type=template&id=4a1de232"
import script from "./Franchigia.vue?vue&type=script&lang=js"
export * from "./Franchigia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports